import React from "react";
import PropTypes from "prop-types";

const PersonPlusIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  ...props
}) => {
  const resolvedStroke = stroke || color || "currentColor";

  return (
    <svg
      width={width || 40}
      height={height || 40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M26.6668 35V31.6667C26.6668 27.9848 23.6821 25 20.0002 25H10.0002C6.31826 25 3.3335 27.9848 3.3335 31.6667V35"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 3.33333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.3335 11.6667C8.3335 15.3461 11.3207 18.3333 15.0002 18.3333C18.6796 18.3333 21.6668 15.3461 21.6668 11.6667C21.6668 7.98723 18.6796 5 15.0002 5C11.3207 5 8.3335 7.98723 8.3335 11.6667"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 3.33333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.6665 13.3333V23.3333"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 3.33333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.6665 18.3333H26.6665"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 3.33333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

PersonPlusIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

PersonPlusIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
};

export default PersonPlusIcon;
